var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleXmark = function SvgCircleXmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#912018",
    d: "M12 3.6a8.4 8.4 0 1 1 0 16.8 8.4 8.4 0 0 1 0-16.8m0 18a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2M9.578 8.73l-.848.848.424.423L11.153 12l-1.999 1.999-.424.423.848.848.424-.424L12 12.848l2 1.998.423.424.847-.848-.423-.423-2-1.999 2-1.999.423-.423-.847-.848-.424.424L12 11.153l-1.998-2z"
  })));
};
export default SvgCircleXmark;